const appGlobalScript = appGlobalScriptNs.default || (() => {});
import * as appGlobalScriptNs from '/home/runner/_work/dc.ncj.global-components-npm/dc.ncj.global-components-npm/src/global/app.ts';
export const globalScripts = appGlobalScript;
export const globalStyles = "";
